export const getAvailabilityFromUserEmployees = (userEmployees, availabilityId, employeeId) => {
  const employee = userEmployees.find(emp => emp.id === employeeId);
  if (!employee) return null;
  const availability = employee.availability_blocks.find(block => block.id === availabilityId);
  return availability || null;
};
